<script>
  import router from '../../../lib/router';
  import { onMount } from 'svelte';
  import { MDCDialog } from '@material/dialog';
  import TextField from '../../../lib/components/TextField.svelte';
  import InputField from '../../../lib/components/InputField.svelte';
  import APIClient from '../../../state-charts/api-client';

  import { TS } from '../../../config/translation-keys.js';
  import { t9n } from '../../../lib/translate.js';
  import DatePicker from '../../../lib/components/DatePicker.svelte';
  import CheckBox from '../../../lib/components/CheckBox.svelte';
  import TimePicker from '../../../lib/components/TimePicker.svelte';
  import session from '../../../lib/session';
  import NumberFieldWithButtons from '../../../lib/components/NumberFieldWithButtons.svelte';
  import {format_float_time} from '../../../lib/utils';
  import { slide } from 'svelte/transition';

  export let order;
  export let order_uuid;
  export let has_inited;

  let original_duration;
  let compl_date;
  let duration;
  let explanation;
  let dialog;
  let short_comment;
  let is_btn_disabled = true;
  let init_clicks = 0;
  let confirmed = {
    date: null,
    init: false
  }
  let is_rating_chosed = false;
  let time_hours_validation = true;
  let change_duration_open = false;

  let complete_ratings = [
    { name: 'sad', is_active: false },
    { name: 'neutral', is_active: false },
    { name: 'happy', is_active: false },
    { name: 'extremely_happy', is_active: false },
  ];

  const is_any_rating_active = () => {
    for(let i = 0; i < complete_ratings.length; i++){
      if(complete_ratings[i].is_active) return true;
    }
    return false;
  }


  const rating_set_active = index => {
    for (let i = 0; i < complete_ratings.length; i++) {
      if (i === index) {
        complete_ratings[i].is_active = true;
      } else {
        complete_ratings[i].is_active = false;
      }
    }
  };

  const get_active_rating = () => {
    for (let i = 0; i < complete_ratings.length; i++) {
      if (complete_ratings[i].is_active) {
        return complete_ratings[i].name;
      }
    }
  };

  const get_rating_icon = rating => {
    if (rating === 'sad') return 'sentiment_very_dissatisfied';
    if (rating === 'neutral') return 'sentiment_dissatisfied';
    if (rating === 'happy') return 'sentiment_satisfied_alt';
    if (rating === 'extremely_happy') return 'sentiment_very_satisfied';
  };

  const submit_complete = async () => {
    let button = document.getElementById('complete_submit');
    if (button) button.disabled = true;

    let data = {
      comment: short_comment,
      order_uuid: order_uuid,
      rating: get_active_rating(),
    }

    if(!!confirmed.date){
      data.confirmed_date = new Date(`${confirmed.date}T00:00`).toISOString();
    } else{
      data.confirmed_order_time = compl_date;
    }



    if(!!duration){
      if(order.product.based_on !== 'product_based_hours'){
        data.duration = duration;
      } else{
        let values = duration.split(":");
        let minutes;
        if(values[1] === '00') minutes = 0;
        if(values[1] === '15') minutes = 0.25;
        if(values[1] === '30') minutes = 0.5;
        if(values[1] === '45') minutes = 0.75;
        data.duration = Number(values[0]) + minutes;
      }
    }
    if(!!explanation) data.duration_change_explanation = explanation;

    if(order.status !== "order_status_delivered"){
      await APIClient.complete_task(data, () => {
          close();
          router.navigate('/orders?completed=true');
          if (button) button.disabled = false;
        }
      );
    } else{
      await APIClient.update_delivered_task(data, () => {
          close();
          if (button) button.disabled = false;
          window.location.reload();
        }
      );
    }


  };

  const init_edit_case = () => {
    let rating = order.feedback.from_worker.rating;
    if(!!rating){
      if (rating === 'sad') complete_ratings[0].is_active = true;
      if (rating === 'neutral') complete_ratings[1].is_active = true;
      if (rating === 'happy') complete_ratings[2].is_active = true;
      if (rating === 'extremely_happy') complete_ratings[3].is_active = true;
    }
    if(!!order.feedback.from_worker.message) short_comment = order.feedback.from_worker.message;
    if(!!order.details.duration && !!order.details.duration_original){
      duration = format_float_time(order.details.duration, true);
    }
    if(!!order.details.duration_change_explanation) explanation = order.details.duration_change_explanation;
  }

  const init_approve = () => {
    dialog = new MDCDialog(document.querySelector(`#complete-dialog`));

    if(order.product.based_on === 'product_based_hours') original_duration = `${format_float_time(order.details.duration)}`;
    if(order.product.based_on === 'product_based_days') original_duration = `${order.details.duration.toFixed(1)} ${t9n(TS.LABEL_DAYS)}`;
    if(order.product.based_on === 'product_based_months') original_duration = `${order.details.duration.toFixed(1)} ${t9n(TS.LABEL_MONTHS)}`;
    if(order.product.based_on === 'product_based_units') original_duration = `${order.details.duration.toFixed(1)} ${t9n(TS.LABEL_UNITS)}`;
    if(order.product.based_on === 'product_based_price') original_duration = `${order.details.duration.toFixed(1)} ${t9n(TS.LABEL_PRICE)}`;

    let init_field = document.getElementById('check-confirmed-init');
    if(!!init_field){
      init_field.addEventListener('change', () => {
        handle_checkbox(confirmed.init)
      })
    }

    if(order.status === "order_status_delivered") init_edit_case()
  };

  const get_btn_status = () => {
    if(order.status !== "order_status_delivered"){
      return !(!!is_rating_chosed && (!!compl_date || !!confirmed.date));
    }
    return !(!!is_rating_chosed);
  }

  const get_btn_status_duration = () => {
    if(!!duration && !!explanation){
      return false;
    }
    if(!!duration && !explanation){
      return true;
    }
    if(!duration && !!explanation){
      return true;
    }
    if(!duration && !explanation){
      return false;
    }
  }

  const add_date_null = (val) => {
    if(val > 10) return val;
    return `0${val}`;
  }

  const handle_checkbox = (val) => {
    if(val){
      init_clicks++;
      if(!!order.details.initial_start_date){
        let date = !!order.details.initial_end_date ? new Date(order.details.initial_end_date) : new Date(order.details.initial_start_date);
        confirmed.date = `${date.getFullYear()}-${add_date_null(date.getMonth() + 1)}-${add_date_null(date.getDate())}`
        document.getElementById('confirmed-date-input').value = `${add_date_null(date.getDate())}-${add_date_null(date.getMonth() + 1)}-${date.getFullYear()}`;

        compl_date = null;
      } else{
        compl_date = order.details.initial_order_time;
        confirmed.date = null;
      }
    } else{
      if(init_clicks > 0){
        compl_date = null;
        confirmed.date = null;

      }
      init_clicks = 0;
    }
    is_btn_disabled = get_btn_status();
    if(!is_btn_disabled) is_btn_disabled = get_btn_status_duration();
  }

  const get_min_val = () => {
    if (order.product.based_on === 'product_based_price') {
      let pp_min = $session.merchant.pilot_points_minimum;
      let pp_multiplier = $session.merchant.pilot_points_multiplier;
      let vat_percentage = $session.merchant.vat_percentage;
      let val = pp_min / pp_multiplier / (1 + vat_percentage);

      val = Number(val.toFixed(1));
      let decimal = Number((val - Math.floor(val)).toFixed(1));

      if (decimal <= 0.5 && decimal > 0) {
        return Number(Math.floor(val).toFixed(0)) + 0.5;
      }
      if (decimal > 0.5) {
        return Number(Math.floor(val).toFixed(0)) + 1;
      }
      if (decimal === 0) {
        return val;
      }
    } else {
      return 1;
    }
  };

  $: if(complete_ratings) is_rating_chosed = is_any_rating_active();
  $: if(is_rating_chosed){
    is_btn_disabled = get_btn_status();
    if(!is_btn_disabled) is_btn_disabled = get_btn_status_duration();
  }
  $: if(compl_date || !compl_date){
    if(compl_date === ''){
      compl_date = null;
      confirmed.init = false;
    }
    is_btn_disabled = get_btn_status();
    if(!is_btn_disabled) is_btn_disabled = get_btn_status_duration();
  }
  $: if(confirmed.date || !confirmed.date){
    if(confirmed.date === ''){
      confirmed.date = null;
      confirmed.init = false;
    }
    is_btn_disabled = get_btn_status();
    if(!is_btn_disabled) is_btn_disabled = get_btn_status_duration();
  }

  $: if(duration || !duration || explanation || !explanation){
    is_btn_disabled = get_btn_status();
    if(!is_btn_disabled) is_btn_disabled = get_btn_status_duration();
  }

  export const open = () => dialog.open();

  export const close = () => dialog.close();

  onMount(init_approve);
</script>

<div id="complete-dialog" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content">

      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2 class="mdc-dialog__title" id="my-dialog-title">
        {#if order.status !== "order_status_delivered"}
          {t9n(TS.ORDER_TASK_COMPLETE)}
        {:else}
          {t9n(TS.ORDER_DETAILS_DURATION_EDIT_INFORMATION)}
        {/if}

      </h2>

      <div
        class="mdc-dialog__content"
        id="my-dialog-content"
        style="z-index: 9999">


        {#if order.status !== "order_status_delivered"}
          <h4 style='margin-left: 20px; margin-top: 20px;'>{t9n(TS.ORDER_ADD_COMPLETION_DATE)} *</h4>
          <div style="margin-left: 20px;">
            <InputField
              id="team-code"
              type="text"
              label={t9n(TS.ORDER_DATE)}
              name="code"
              is_required={true}
              bind:value={compl_date}
              is_tooltip_default={false}
              disabled={!!confirmed.date || !!confirmed.init}
              tooltip_default_text="Displayed in your certificate."
              width="410px" />
          </div>

          <!--        TODO: translation here-->

          <div style='display: flex; margin-bottom: 15px; margin-left: 20px;'>
            <DatePicker
              id='confirmed-date'
              is_required={true}
              label={t9n(TS.WORKER_REPORTS_COMPLETION_DATE_LABEL)}
              bind:value={confirmed.date}
              disabled={!!compl_date || !!confirmed.init}
            />
            <div style='margin-top: 15px; margin-left: 15px;'>
              <CheckBox
                bind:value={confirmed.init}
                id='confirmed-init'
                label={t9n(TS.TABLE_HEADER_INIT_TIME)} />
            </div>
          </div>
        {/if}


        {#if order.duration_can_be_modified}
        <div style="padding-left: 20px; padding-right: 20px;">
          <h4>{t9n(TS.ORDER_CHANGE_DURATION_IF_NEEDED)}</h4>
          <button id="change_button" class="mdc-button mdc-button--outlined desktop-width"
                  on:click|stopPropagation|preventDefault={() => { change_duration_open = !change_duration_open }}>
            <span class="mdc-button__ripple"/>
            {t9n(TS.ORDER_CHANGE_DURATION)}
          </button>
<!--          <h4>{t9n(TS.ORDER_DETAILS_DURATION_LABEL)}</h4>-->


            <!--{t9n(TS.ORDER_DETAILS_DURATION_CANT_MODIFY)}-->
          {#if change_duration_open}
              <div transition:slide|local>
                <p>{`${t9n(TS.ORDER_DETAILS_DURATION_WARNING_ORIGINAL)}: ${original_duration}`}</p>
                <p>{t9n(TS.ORDER_DETAILS_DURATION_INFO)}</p>
                {#if order.product.based_on === 'product_based_hours'}
                  <div style='width: 199px'>
                    <TimePicker
                      id='duration'
                      label={`${t9n(t9n(TS.ORDER_DETAILS_DURATION_LABEL))} (${t9n(order.product.based_on)})`}
                      bind:value={duration}
                      default_val={true}
                      is_15_minutes_scale={true}
                      disabled={!order.duration_can_be_modified} />
                  </div>
                {:else}
                  <NumberFieldWithButtons
                    id='duration'
                    type='text'
                    label={`${t9n(t9n(TS.ORDER_DETAILS_DURATION_LABEL))} (${t9n(order.product.based_on)})`}
                    name='duration'
                    bind:value={duration}
                    width='199px'
                    show_tooltip={false}
                    disabled={!order.duration_can_be_modified}
                    bind:time_hours_validation
                    min_val={get_min_val()} />
                {/if}

                <div style='margin-top: 15px;'>
                  <InputField
                    id="explanation"
                    type="text"
                    label={t9n(TS.ORDER_DETAILS_DURATION_EXP)}
                    name="code"
                    bind:value={explanation}
                    disabled={!order.duration_can_be_modified}
                    width="410px" />
                </div>
              </div>

            {/if}


        </div>
        {/if}

        <div style="padding-left: 20px; padding-right: 20px;">
          <h4>{t9n(TS.ORDER_RATE_ORDERER)}</h4>
          <p>{t9n(TS.ORDER_FEEDBACK_TEXT)}</p>
        </div>

        <div style="padding-left: 20px; padding-right: 20px;">
          <h4>{t9n(TS.ORDER_CHOOSE_RAT)} *</h4>
        </div>

        {#each complete_ratings as rating, i}
          <a href="javascript:;" on:click={() => rating_set_active(i)}>
            <i
              class="material-icons"
              class:ratings={i === 0}
              class:active-icon={rating.is_active}>
              {get_rating_icon(rating.name)}
            </i>
          </a>
        {/each}

        <div style="margin-top: 15px; margin-left: 20px;">
          <TextField
            bind:value={short_comment}
            label={t9n(TS.ORDER_SHORT_COMMENT)}
            max_chars={20000}
            show_counter={false}
            width="530px"
            id="complete-textfield" />
        </div>

      </div>

      <footer class="mdc-dialog__actions">
        <!--                {#each buttons as button}-->
        <!--                    <button class="mdc-button mdc-button&#45;&#45;raised {button.classes}"-->
        <!--                            tabindex="0"-->
        <!--                            on:click|preventDefault|stopPropagation={button.action}>-->
        <!--                        {button.label}-->
        <!--                    </button>-->
        <!--                {/each}-->
        <p class='required'>* {t9n(TS.REQUIRED_LABEL)}</p>
        <button
          on:click={() => close()}
          class="mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {t9n(TS.TXT_CANCEL)}
        </button>

        <button
          id='complete_submit'
          disabled={is_btn_disabled}
          on:click={async () => { await submit_complete() } }
          class="btn-close mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {t9n(TS.ORDER_SUBMIT)}
        </button>
      </footer>


    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<style>
    .required{
        font-size: 10pt;
        color: #323232;
        margin-left: 20px;
        position: absolute;
        left: 25px;
    }

  .btn-close {
    margin-left: 5px;
  }

  #complete-dialog .mdc-dialog__surface {
    max-width: 500px;
    width: 500px;
  }

  #complete-dialog .material-icons {
    font-size: 50pt;
    color: var(--worker-background-color);
    opacity: 50%;
  }

  #complete-dialog .material-icons:hover {
    opacity: 70%;
  }

  #complete-dialog .active-icon {
    opacity: 100%;
    animation: transition_in 0.3s;
  }

  .ratings {
    margin-left: 90px;
  }

  /* Mobile Mode
  *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    #complete-dialog .mdc-dialog__surface {
      max-width: unset;
      width: 350px;
      margin-bottom: 50px;
    }

    .ratings {
      margin-left: 0;
    }
  }
</style>
